export default "__VITE_ASSET__CEUgQIEi__"